import burgerInit from "./components/burger.js";
import initHeadersAnimations from "./components/headerAnimations.js";
import initGallery from "./components/photoswipe.js";
import initReservationsPopup from "./components/reservations.js";
import initVideoControls from "./components/videoMuteToggle.js";
import formValidation from "./components/form-validation.js";
import showMore from "./components/showmore.js";
import initMap from "./components/map.js";
import scrollToAnchor from "./components/scrollToAnchor.js";

burgerInit();
initReservationsPopup();
// initVideoControls();
initGallery();
initHeadersAnimations();
formValidation();
showMore();
// initMap();
scrollToAnchor();
